const types = {
  VALIDATE_ZIPCODE: '@@PO_admin/VALIDATE_ZIPCODE',
  GET_FOCUS: '@@PO_admin/GET_FOCUS',
};

export default types;
